<template>
	<div class="wl-home-wrapper">
		<div class="home-wl-intro-content">
			<div class="home-news-box">
				<div class="news-left">
					<el-carousel height="380px" :interval="50000">
						<el-carousel-item v-for="(item,index) in notList" :key="index">
							<div class="news-cover-bg" :style="`background-image: url(${item.cover || newsCover})`" @click="goNewsDetail(2,item.id)">
								<div class="news-head-title">
									<p class="title-text">{{ item.title }}</p>
								</div>
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="news-right">
					<div class="head-title">
						<span class="sp-title">新闻公告</span>
						<span class="sp-more" @click="$router.push({name:'xNewsCenter'})">更多 <i class="wl-icon-xiangyoushixinjiantou"></i></span>
					</div>
					<template v-if="newList.length>0">
						<div class="news-top-title" @click="goNewsDetail(1, newList[0].id)">{{ newList[0].title }}</div>
						<!-- <div class="news-top-content" @click="goNewsDetail(1, newList[0].id)" v-html="newList[0].contentText"></div> -->
					</template>
					
					<div class="news-list">
						<div class="news-item-li" v-for="(item,index) in newList" :key="index" v-show="index>0" @click="goNewsDetail(1,item.id)">
							<div class="news-li-text"><i class="wl-icon-dian1"></i>{{ item.title }}</div>
							<div class="news-li-time">{{ item.month }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="home-box-select">
				<ul class="box-list">
					<li class="li-item" @click="enterRelantFile">
						<div class="icon-li"><i class="wl-icon-ziyuan"></i></div>
						<p class="p-text">试点相关文件</p>
					</li>
					<li class="li-item" @click="handleCommand('a')">
						<div class="icon-li"><i class="wl-icon-jiangbei01"></i></div>
							<p class="p-text">大赛专题</p>
					</li>
					<li class="li-item" @click="applyPosition">
						<div class="icon-li"><i class="wl-icon-kechengxuexi"></i></div>
							<p class="p-text">学习中心</p>
					</li>
					<li class="li-item" @click="goYkt">
						<div class="icon-li"><i class="wl-icon-jiaoxueguanli"></i></div>
							<p class="p-text">中物联云课堂</p>
					</li>
					<li class="li-item" @click="$router.push({name:'mockCertifySelect'})">
						<div class="icon-li"><i class="wl-icon-ceyan"></i></div>
							<p class="p-text">模拟练习平台</p>
					</li>
					<li class="li-item" @click="$router.push({ name: 'certifyIndex' })">
						<div class="icon-li"><i class="wl-icon-chaxun4"></i></div>
							<p class="p-text">证书查询</p>
					</li>
				</ul>
			</div>
		</div>
		<div class="show-all-wl-site-content" :style="{ backgroundImage: 'url(' + allSiteBgImg + ')' }" v-if="hideHomePart">
			<div class="all-wl-site-con">
				<div>
					<img src="../../assets/images/wx-line-img.png" alt />
				</div>
				<div class="all-site-title">全国物流认证站点</div>
				<h4 class="sub-head-title">NATIONAL LOGISTICS CERTIFICATION SITE</h4>
				<div class="map-all-site-con clearfix">
					<div class="map-site-show fl">
						<echarts :options="mapEchartsData" style="width: 623px; height: 512px" @click="getSiteDetail"></echarts>
					</div>
					<div class="wl-cerfity-site-con fr">
						<div class="site-num-con clearfix">
							<div class="fl site-num-con-w">
								<p class="p-num-con">
									<span class="num-con-val">{{ sitesData.ExamSiteCount }}</span>
									<span class="num-con-unit">所</span>
								</p>
								<p class="p-site-label">考 试 站 点</p>
							</div>
							<div class="fl site-num-con-w">
								<p class="p-num-con">
									<span class="num-con-val">{{ sitesData.TrainSiteCount }}</span>
									<span class="num-con-unit">所</span>
								</p>
								<p class="p-site-label">培 训 站 点</p>
							</div>
							<div class="fl site-num-con-w">
								<p class="p-num-con">
									<span class="num-con-val">{{ sitesData.teaCount }}</span>
									<span class="num-con-unit">名</span>
								</p>
								<p class="p-site-label">认 证 讲 师</p>
							</div>
							<div class="fl site-num-con-w">
								<p class="p-num-con">
									<span class="num-con-val">{{ sitesData.stuCount }}</span>
									<span class="num-con-unit">名</span>
								</p>
								<p class="p-site-label">认 证 学 员</p>
							</div>
						</div>
						<!-- <div class="apply-site-btn" @click="declare">申报站点 >></div> -->
						<div class="apply-site-head clearfix">
							<span class="fl">全国物流认证站点</span>
							<span class="fr sp-site-more" @click="goSietView">查看更多</span>
						</div>
						<div class="clearfix">
							<div class="fl show-site-net-li clearfix" v-for="(li, index) in sitesList" :key="index">
								<i class="wl-icon-dian fl"></i>
								<div class="site-new-li-word">{{ li }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="wl-xc-img-con" v-if="hideHomePart">
			<img src="../../assets/images/wl-xc-img.png" alt />
		</div>
		<div class="study-source-content">
			<div class="study-source-con">
				<div class="home-head">精彩之窗</div>
				<div class="tea-material-content clearfix">
					<swiper :options="swiperOption">
						<swiper-slide v-for="(item, index) in windowList" :key="index">
							<div class="ph-slide-course-con" v-if="index < 4" @click="windowLink(item.Link)" :style=" item.Link?'cursor: pointer;': ''">
								<div class="ph-course-cover-con">
									<img :src="item.DocUrl" alt />
								</div>
								<p class="ph-ex-course-name">{{ item.BannerTitle }}</p>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
		<div class="ship-link-con">
			<div class="ship-lini-list">
				<div class="link-title">友情链接：</div>
				<div class="clearfix a-links-main">
					<ul>
						<li><a href="https://www.moe.gov.cn/" target="_blank">中华人民共和国教育部</a></li>
						<li><a href="http://www.chinawuliu.com.cn/" target="_blank">中国物流与采购联合会</a></li>
					</ul>
					<ul>
						<li><a href="http://www.civte.edu.cn/" target="_blank">教育部职业技术教育中心研究所</a></li>
						<li><a href="http://47.103.191.18/html/logistics_p/" target="_blank">全国物流职业教育教学指导委员会</a></li>
					</ul>
					<ul style="width: 410px;">
						<li><a href="https://vslc.ncb.edu.cn/" target="_blank">职业技能等级证书信息管理服务平台</a></li>
						<li><a href="http://47.103.191.18/html/logistics_t/" target="_blank">教育部高等学校物流管理与工程类专业教学指导委员会</a></li>
					</ul>
					<ul>
						<li><a href="https://www.ncb.edu.cn/" target="_blank">职业教育国家学分银行</a></li>
					</ul>
				</div>
			</div>
		</div>
		<!-- 登录弹框 -->
		<newLogin :isShow="showObject" :isJumpWeb="isJumpWeb"></newLogin>
	</div>
</template>

<script>
import newLogin from 'components/newLogin.vue';
export default {
	components: {
		newLogin,
	},
	data() {
		return {
			NewsimgUrl: 'https://file.clpp.org.cn/66ykt/ori/qe1aogpg4xhg8t0uh9blq/Jff3zkhEX2AGGrFB.jpg',
			newsCover: require('assets/images/news-cover.png'),
			NewToplist: [],
			isNewDynaic: true,
			allSiteBgImg: require('assets/images/all-site-bg.png'),
			mapEchartsData: {},
			backList: [require('assets/images/test-bg-1.png'), require('assets/images/test-bg-2.png'), require('assets/images/test-bg-3.png')],
			testBg1: require('assets/images/test-bg-1.png'),
			testBg2: require('assets/images/test-bg-2.png'),
			testBg3: require('assets/images/test-bg-3.png'),
			testBg4: require('assets/images/test-bg-4.png'),
			fadeWidth: 216,
			fadeNum: 0,
			myChart: '',
			wonderfulData: [],
			swiperOption: {
				slidesPerView: 4,
				spaceBetween: 25,
				loop: true,
				autoplay: {
					delay: 2500,
					disableOnInteraction: false,
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
			},
			type: 1,
			newList: [],
			notList:[],
			sitesData: {},
			data: [],
			sitesList: [],
			info: {
				Name: '',
				Introduce: '',
			},
			bannerList: [],
			windowList: [],
			introduceList: [],
			hideHomePart: false,
			wlIntroduce: '',
			showObject: {
				isShow: true,
			},
			isJumpWeb: false,
			associationId: '',
		};
	},
	computed: {
		userInfo() {
			return this.$store.state.auth;
		},
		transform() {
			return 'translateX(-' + this.fadeWidth * this.fadeNum + 'px)';
		},
		associationassociation: function () {
			return this.$store.state.association;
		},
	},
	mounted() {
		this.myChart = this.$refs.myEchart;
	},
	watch: {
		associationassociation(val) {
			this.associationId = val.Id;
			this.getSitesMap();
			this.getAssociationInfo();
			this.getNewsr();
			this.getNot();
			this.getSitesCount();
			this.getBanner();
			this.getIntroduceListList();
		},
	},
	created() {
		this.getSitesMap();
		// this.getAssociationInfo();
		this.getNewsr();
		this.getNot();
		this.getSitesCount();
		this.getBanner();
		this.getIntroduceListList();
	},
	methods: {
		handleCommand(command) {
			let host = window.location.host;
			let url = host.indexOf('localhost') > -1 ? 'http://localhost:8086/questionList' : 'http://cykw.clpp.org.cn/questionList';
			if (command == 'a') {
				window.open(url + '/1');
			} else {
				window.open(url + '/1');
			}
		},
		downloadExam() {
			this.$router.push({
				name: 'downLoad',
			});
		},
		windowLink(url) { 
			if (url) {
				window.open(url);
			}
		},
		applyPosition() {
			// if(this.userInfo.code < 0){
			//   this.openLogin();
			//   return;
			// }
			// this.$router.push({
			//   name: "committeeTable"
			// });
			// 物流行指委专委会委员申报
			this.$router.push({
				name: 'metarialCenter',
			});
		},
		goYkt(){
			window.open('http://ykt.clppx.org.cn/wlykt/home');
		},
		openLogin() {
			this.showObject = {
				isShow: true,
			};
		},
		tipTextExam() {
			this.$message.warning('请在电脑端操作!');
		},
		goMeetRegister() {
			this.$router.push({
				name: 'meetRegister',
			});
		},
		enterStandard() {
			this.$router.push({
				name: 'introStandard',
			});
		},
		enterMorenNews() {
			this.$router.push({
				name: 'xNewsCenter',
			});
		},
		goDetail(index) {
			this.$router.push({
				name: 'xIntro',
				params: {
					tabIndex: index,
				},
			});
		},
		goSite() {
			this.$router.push({
				name: 'certifySite',
			});
		},
		goLecturer() {
			this.$router.push({
				name: 'certifLecturer',
			});
		},
		enterRelantFile() {
			this.$router.push({
				name: 'xNewsCenter',
			});
		},
		goCertificateStu() {
			this.$router.push({
				name: 'themeActivity',
			});
		},
		getSiteDetail(val) {
			console.log(val.name);
		},
		getNewsDynamic() {
			this.type = 1;
			this.getNewsr();
			this.isNewDynaic = true;
		},
		getActivityNotice() {
			this.type = 2;
			this.getNewsr();
			this.isNewDynaic = false;
		},
		getMapData() {
			this.mapEchartsData = {
				title: {
					text: '',
					subtext: '',
					x: 'center',
					textStyle: {
						color: '#fff',
					},
				},
				tooltip: {
					trigger: 'item',
					formatter: function (params) {
						return params.name + ' : ' + params.value[2];
					},
				},
				visualMap: {
					min: 0,
					max: 200,
					show: false,
					calculable: false,
					inRange: {
						color: ['#65a0f7'],
					},
					textStyle: {
						color: '#fff',
					},
				},
				geo: {
					map: 'china',
					layoutCenter: ['50%', '50%'],
					layoutSize: 630,
					label: {
						emphasis: {
							show: false,
						},
					},
					itemStyle: {
						normal: {
							areaColor: '#F4F5F7',
							borderColor: '#111',
						},
						emphasis: {
							areaColor: '#ECF0F3',
						},
					},
					regions: [
						{
							name: '南海诸岛',
							value: 0,
							show: false,
							itemStyle: {
								normal: {
									opacity: 0,
									label: {
										show: false,
									},
									color: '#71D4E7',
								},
							},
						},
					],
				},
				series: [
					{
						name: 'pm2.5',
						type: 'effectScatter',
						scaling: 1.7,
						//该系列使用的坐标系
						coordinateSystem: 'geo',
						symbolSize: function (val) {
							return val[2] / 1;
						},
						data: this.data,
						//配置何时显示特效'render' 绘制完成后显示特效。'emphasis' 高亮（hover）的时候显示特效。
						showEffectOn: 'render',
						//目前只有ripple这一种
						effectType: 'ripple',
						//涟漪特效相关配置。
						rippleEffect: {
							//动画的时间
							period: 4,
							//动画中波纹的最大缩放比例
							scale: 4,
							//波纹的绘制方式可选 'stroke' 和 'fill'
							brushType: 'stroke',
						},
						//Scatter才有这个属性,是否开启鼠标 hover 的提示动画效果
						hoverAnimation: true,
					},
				],
			};
		},
		toMaterialDetail() {},
		getNewsr() {
			var that = this;
			this.$http
				.post('/api/XOrg/AssociationIndex/getNewsr', {
					type: 1,
					pagesize: 9,
					associationId: this.associationId,
				})
				.then(function (rst) {
					that.newList = rst.list;
				});
		},
		getNot() {
			var that = this;
			this.$http
				.post('/api/XOrg/AssociationIndex/getNewsr', {
					type: 2,
					pagesize: 5,
					associationId: this.associationId,
				})
				.then(function (rst) {
					that.notList = rst.list;
				});
		},
		getSitesCount() {
			var that = this;
			this.$http
				.post('/api/XOrg/AssociationIndex/getSitesCountTop', {
					associationId: this.associationId,
				})
				.then(function (rst) {
					that.sitesData = rst.data;
					that.sitesList = rst.siteList;
				});
		},
		getAssociationInfo() {
			var that = this;
			this.$http
				.post('/api/XOrg/AssociationIndex/getAssociationInfo', {
					associationId: this.associationId,
				})
				.then(function (rst) {
					that.info = rst.info;
					that.wlIntroduce = rst.info.Introduce;
				});
		},
		getBanner() {
			this.$http
				.post('/api/XOrg/AssociationIndex/getBanner', {
					associationId: this.associationId,
				})
				.then((rst)=> {
					// (that.bannerList = rst.bannerList),
						this.windowList = rst.windowList;
				});
		},
		getSitesMap() {
			var that = this;
			this.$http
				.post('/api/XOrg/AssociationIndex/getSitesMap', {
					associationId: this.associationId,
				})
				.then(function (rst) {
					that.data = rst.list;
					that.getMapData();
				});
		},
		getIntroduceListList() {
			var that = this;
			this.$http
				.post('/api/XOrg/AssociationIndex/getIntroduceListList', {
					associationId: this.associationId,
				})
				.then(function (rst) {
					that.introduceList = rst.introduceList;
				});
		},
		goNewsDetail(type,newsId) {
			this.$router.push({
				name: 'newsDetail',
				params: {
					newsId: newsId,
					isTab: type,
				},
			});
		},
		goSietView() {
			this.$router.push({
				name: 'certifySite',
			});
		},
		kaoHeManager() {
			let Urlname = '';
			if (this.$store.state.auth.userType === 1) {
				Urlname = 'stuBasicInfo';
			} else if (this.$store.state.auth.userType === 2) {
				Urlname = 'managerIndex';
			} else if (this.$store.state.auth.userType === 3) {
				Urlname = 'siteBasicInfo';
			} else if (this.$store.state.auth.userType === 5) {
				Urlname = 'managerIndex';
			}
			if (this.$store.state.auth.userType > 0) {
				this.$router.push({
					name: Urlname,
				});
			} else {
				// this.hidePhoneMenu();
				this.openLogin();
			}
		},
		declare() {},
	},
};
</script>

<style lang="scss"></style>
